import { useEffect, useState } from 'react';
import { UserApi } from '../../../api';
import { useContainer } from '../../useContainer';
import { TopicDto } from '../../../commonTypes/user.types';

const useHttpGetTopicsByCategoryNameOnMount = (categoryName: string) => {
    const userApi: UserApi = useContainer(UserApi);
    const [isReady, setIsReady] = useState(false);
    const [data, setData] = useState<TopicDto[]>([]);

    const { exec, abort } = userApi.getTopicsByCategoryName({
        query: { categoryName },
        onSuccess: res => {
            setData(res.body);
        },
        onError: error => console.error(error),
        onFinally: () => setIsReady(true),
    });

    useEffect(() => {
        exec();
        return abort;
    }, []);

    return { exec, isReady, data };
};

export default useHttpGetTopicsByCategoryNameOnMount;
